// extracted by mini-css-extract-plugin
module.exports = {"container":"NsMinimalDrawer_container_1qjfK","scrim":"NsMinimalDrawer_scrim_Ob2nl","content":"NsMinimalDrawer_content_3sjLl"};